<template>
  <AdapterForm
    :adapter="adapter"
    :service="service"
    :is-replacement="isReplacement"
    :show-remove="showRemove"
    @change="$emit('change', $event)"
    @remove="$emit('remove', $event)"
    @exchange="$emit('exchange', $event)"
    @service-type-change="$emit('serviceTypeChange', $event)"
  />
</template>
<script setup lang="ts">
import AdapterForm from './AdapterForm.vue';
import { Adapter } from '@/models/installationPoint/Accessory';
import { AccessoryService } from '@/models/installationPoint/AccessoryService';

const props = defineProps<{
  adapter: Adapter;
  service?: AccessoryService;
  isReplacement?: boolean;
  disabled?: boolean;
  showRemove?: boolean;
}>();

defineEmits<{
  (e: 'change', adapter: Adapter): void;
  (
    e: 'exchange',
    payload: {
      oldAdapter: Adapter;
      newAdapter: Adapter;
      service?: AccessoryService;
    }
  ): void;
  (e: 'remove', adapter: Adapter): void;
  (e: 'serviceTypeChange', payload: any): void;
}>();
</script>
